import { computed, ref, Ref } from 'vue';
import { SubmitUploadStatuses } from '@/models/submit-upload-statuses.enum';
import { ModalReviewUploadState } from '@/models/modal/modal.enum';
import { SurveyQuestion } from '@studyportals/sp-lurch-interface';
import UploadPresenter from '@/presenters/upload-presenter';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import lurchClient from '@/infrastructure/lurch-client';
import store from '@/store';

export default class MatchingComponent {
	public surveyQuestions: Ref<SurveyQuestion[]> = ref([]);
	public submitUploadInProgress = computed((): boolean => {
		return this.submitUploadStatus.value !== SubmitUploadStatuses.INACTIVE && this.submitUploadNotFinishedYet.value;
	});

	public shouldModalBeShown = computed((): boolean => {
		return this.modalReviewUploadState.value !== ModalReviewUploadState.INACTIVE;
	});

	private modalReviewUploadState = computed((): ModalReviewUploadState => {
		return store.getters.modalReviewUploadState();
	});

	public submitUploadNotFinishedYet = computed((): boolean => {
		return (
			this.submitUploadStatus.value !== SubmitUploadStatuses.MATCHES_FOUND &&
			this.submitUploadStatus.value !== SubmitUploadStatuses.NO_MATCHES_FOUND
		);
	});

	public recruitmentStageAsText = computed((): string => {
		return UploadPresenter.retrieveRecruitmentStageWithAmountAsText();
	});

	public intakePeriodAsText = computed((): string => {
		const text = UploadPresenter.retrieveIntakePeriodAsText(false);
		if (!text) {
			return '';
		}

		return `&nbsp;for the intake period ${text}`;
	});

	private submitUploadStatus = computed((): SubmitUploadStatuses => {
		return store.getters.submitUploadStatus();
	});

	public async mounted(): Promise<void> {
		try {
			this.surveyQuestions.value = await lurchClient.retrieveSurvey();
		} catch (error) {
			rollbarOperator.triggerError('Failed to retrieve survey questions.', error);
		}
	}
}
